export function arrayUniqueBy<T>(array: T[], f: (e: T) => any): T[] {
  const s = new Set();
  return array.filter((e) => {
    const key = f(e);
    return s.has(key) ? false : s.add(key);
  });
}

export function arrayEquals(arrA: any[], arrB: any[]): boolean {
  if (arrA.length !== arrB.length) {
    return false;
  }

  return arrA.every((value, index) => value === arrB[index]);
}
